var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute top-14 left-8"},[_c('router-link',{attrs:{"to":_vm.to}},[_c('i',{staticClass:"text-2xl fas fa-arrow-alt-circle-left"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }